// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {FormattedMessage} from 'react-intl';
import WarrantyDateRangePicker from '../../../shared/components/warranty-date-range-picker/warranty-date-range-picker';

const WarrantyExpirationDates = props =>
    <section className='warranty-expiration-dates'>
        <h5 className='warranty-expiration-date-label asterisk-after'>
            <FormattedMessage id={props.label}/>
        </h5>
        <WarrantyDateRangePicker
            dateRange={props.dateRange}
            maxDate={props.dateRange.max}
            minDate={props.dateRange.min}
            onDateChange={props.onDateChange}
        />
    </section>;

WarrantyExpirationDates.displayName = 'WarrantyExpirationDates';
WarrantyExpirationDates.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange).isRequired,
    label: PropTypes.string.isRequired,
    onDateChange: PropTypes.func.isRequired
};

export default WarrantyExpirationDates;



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/components/warranty-expiration-dates.js